import * as requests from '../node/requests'
import ApiAdapter from './apiAdapter'

class NodeAdapter extends ApiAdapter {
  requests() {
    return requests
  }
}

export default NodeAdapter
